
import {isEmpty} from 'lodash';
import {DateUtil} from '../../utils/date-util.js';
import {DASHBOARD_TOP_TABS_VALUE} from "../../utils/constants";

export const getDefaultDateRanges = (format, recommCompetitor) => {
    const defaultDateRanges = {
        Today: [
            DateUtil.formatDate(DateUtil.getNowMoment().toDate(), format),
            DateUtil.formatDate(DateUtil.getNowMoment().toDate(), format)
        ],
        Yesterday: [
            DateUtil.formatDate(DateUtil.subtractDaysInMoment(DateUtil.getNowMoment(), 1).toDate(), format),
            DateUtil.formatDate(DateUtil.subtractDaysInMoment(DateUtil.getNowMoment(), 1).toDate(), format),
        ],
        'Last 1 Day': [
            DateUtil.formatDate(DateUtil.subtractDaysInMoment(DateUtil.getNowMoment(), 1).toDate(), format),
            DateUtil.formatDate(DateUtil.getNowMoment().toDate(), format)
        ],
        'Last 7 Days': [
            DateUtil.formatDate(DateUtil.subtractDaysInMoment(DateUtil.getNowMoment(), 6).toDate(), format),
            DateUtil.formatDate(DateUtil.getNowMoment().toDate(), format)
        ]
    };

    if (isEmpty(recommCompetitor) || recommCompetitor === DASHBOARD_TOP_TABS_VALUE.RECOMMENDATION){
        defaultDateRanges['Last 30 Days'] = [
            DateUtil.formatDate(DateUtil.subtractDaysInMoment(DateUtil.getNowMoment(), 29).toDate(), format),
            DateUtil.formatDate(DateUtil.getNowMoment().toDate(), format)
        ];
    } else {
        defaultDateRanges['Last 15 Days'] = [
            DateUtil.formatDate(DateUtil.subtractDaysInMoment(DateUtil.getNowMoment(), 14).toDate(), format),
            DateUtil.formatDate(DateUtil.getNowMoment().toDate(), format)
        ];
    }

    return defaultDateRanges;
};
